import React, { useState } from "react";
import { CustomTable } from "../../../components/Table";
import { createColumnHelper } from "@tanstack/react-table";
import { capitalizeFirstLetter } from "../../../utils/utility";
import copyIcon from "../../../assets/copy.svg";
import sortIcon from "../../../assets/sort.svg";
import downloadIcon from "../../../assets/download.svg";
import exportIcon from "../../../assets/export.svg";
import infoIcon from "../../../assets/info.svg";
import CustomTableWithScroll from "../../../components/CustomTableWithScroll";
import { date_DD_MMM_YYY } from "../../../utils/dateFormater";
import { formatCurrency } from "../../../utils/helper";

interface IInvoiceDataProps {
  setCodModal?: any;
  setAwbModal?: any;
  tableData?: any[];
  downloadReport?: (reportNumber: any) => Promise<void>;
  setSortReportByDate?: any;
}

const CodData: React.FunctionComponent<IInvoiceDataProps> = ({
  setCodModal,
  setAwbModal,
  tableData,
  downloadReport,
  setSortReportByDate,
}) => {
  const columnsHelper = createColumnHelper<any>();
  const billingOrdersHeading = [
    columnsHelper.accessor("reportDate", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <h1 className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Report Date
            </h1>
            <img
              className="cursor-pointer"
              src={sortIcon}
              alt=""
              onClick={() =>
                setSortReportByDate((prev: any) => (prev == 1 ? -1 : 1))
              }
            />
          </div>
        );
      },
      cell: (info: any) => {
        return (
          <div className="py-4">
            <p className="font-Open text-xs font-normal leading-4">
              {info.row?.original?.reportDate
                ? date_DD_MMM_YYY(info.row?.original?.reportDate)
                : info.row?.original?.reportNumber}
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("reportRefNo", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <h1 className="font-Open text-sm font-semibold leading-5 text-[#1C1C1C] self-center ">
              Report Ref No
            </h1>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        return (
          <div>
            <p className="font-Open text-xs font-normal leading-4">
              {info.row.original.reportNumber}
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("CodAmount", {
      header: () => {
        return (
          <div className="flex justify-between">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Cod Amount
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        return (
          <div className="">
            <p className="font-Open text-xs font-normal leading-4">
            ₹ {formatCurrency(info?.row?.original?.details?.codAmountRemittable || 0)}
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("addonCharges", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Addon Charges
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        return (
          <div className="font-Open font-normal leading-4 text-xs">
            <p>₹{formatCurrency(info.row?.original?.addonCharges || 0)}</p>
          </div>
        );
      },
    }),

    columnsHelper.accessor("recoveryAmount", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Recovery Amount
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        return (
          <div
            className="font-Open font-normal leading-4 text-xs "
            onClick={() =>
              setCodModal({ isOpen: true, data: info?.row?.original })
            }
          >
            <p>₹{formatCurrency(info.row.original?.details?.totalRecoveredAmount || 0)}</p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("codRecharge", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Cod Recharge
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        return (
          <div className="font-Open font-normal leading-4 text-xs ">
            <p>₹{formatCurrency(info.row.original?.details?.codRecharge || 0)}</p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("netPaid", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Net Paid
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        //   info.row.original?.netPaid;

        return (
          <div className="font-Open font-normal leading-4 text-xs ">
            <p className="text-[#5958FF] cursor-pointer">
              ₹ {formatCurrency(info?.row?.original?.details?.codAmountRemitted)}
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("paymentRefNo", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Payment Ref No
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        //   ₹ info.row.original?.netPaid;

        return (
          <div className="font-Open font-normal leading-4 text-xs ">
            {info?.row?.original?.details?.utrNo}
          </div>
        );
      },
    }),
    columnsHelper.accessor("orderId", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              OrderId
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        const orderId = info?.row?.original?.details?.orderIds;
        // Calculate the count of AWBs
        const orderIdCount = Array.isArray(orderId) ? orderId?.length : 0;

        return (
          <div
            className=""
            onClick={() =>
              setAwbModal({
                isOpen: true,
                data: info?.row?.original?.details?.orderIds,
                recovery: false,
                isAWB:false,
                isOrderId: true,
                isOrderNum: false,
              })
            }
          >
            {/* <p>₹{info.row.original?.recoveryAmount}</p> */}
           <p className="text-[#5958FF] text-xs cursor-pointer">
              {orderIdCount === 0 ? 'NA' : `${orderIdCount} Order Id`}
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("orderNumber", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
               Order Number
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        const orderNumbers = info?.row?.original?.details?.channelNumbers;
        // Calculate the count of AWBs
        const orderNumberCount = Array.isArray(orderNumbers) ? orderNumbers?.length : 0;

        return (
          <div
            className=""
            onClick={() =>
              setAwbModal({
                isOpen: true,
                data: info?.row?.original?.details?.channelNumbers,
                recovery: false,
                isAWB:false,
                isOrderId: false,
                isOrderNum: true,
              })
            }
          >
            {/* <p>₹{info.row.original?.recoveryAmount}</p> */}
            <p className="text-[#5958FF] text-xs cursor-pointer">
              {orderNumberCount === 0 ? 'NA' : `${orderNumberCount} Order Number`}
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("awb", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              AWB
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        const awbNumbers = info?.row?.original?.details?.awbNos;
        // Calculate the count of AWBs
        const awbCount = Array.isArray(awbNumbers) ? awbNumbers?.length : 0;

        return (
          <div
            className=""
            onClick={() =>
              setAwbModal({
                isOpen: true,
                data: info?.row?.original?.details?.awbNos,
                recovery: false,
                isAWB:true,
                isOrderId: false,
                isOrderNum: false,
              })
            }
          >
            {/* <p>₹{info.row.original?.recoveryAmount}</p> */}
            <p className="text-[#5958FF] text-xs cursor-pointer">
              {awbCount} AWB
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("awb", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Recoverd AWB
            </p>
            <img className="cursor-pointer" src={sortIcon} alt="" />
          </div>
        );
      },

      cell: (info: any) => {
        const awbNumbers = info?.row?.original?.details?.recoveryAwbNos;
        // Calculate the count of AWBs
        const awbCount = Array.isArray(awbNumbers) ? awbNumbers?.length : 0;

        return (
          <div
            className=""
            onClick={() =>
              setAwbModal({
                isOpen: true,
                data: info?.row?.original?.details?.recoveryAwbNos,
                recovery: true,
                isAWB:false,
                isOrderId: false,
                isOrderNum: false,
              })
            }
          >
            {/* <p>₹{info.row.original?.recoveryAmount}</p> */}
            <p className="text-[#5958FF] text-xs cursor-pointer">
              {awbCount} AWB
            </p>
          </div>
        );
      },
    }),
    columnsHelper.accessor("actions", {
      header: () => {
        return (
          <div className="flex justify-between ">
            <p className="font-Open text-sm font-semibold leading-5  text-[#1C1C1C] self-center ">
              Actions
            </p>
          </div>
        );
      },

      cell: (info: any) => {
        return (
          <div
            className="flex justify-center gap-x-5 max-w-[50px]"
            onClick={() =>
              downloadReport && downloadReport(info.row.original.reportNumber)
            }
          >
            <img className="cursor-pointer" src={downloadIcon} alt="" />
          </div>
        );
      },
    }),
  ];

  const fixedCol = ["reportDate", "actions"];
  return (
    <div>
      {/* <CustomTableWithScroll
        columns={billingOrdersHeading}
        data={tableData}
        fixedData={fixedCol}
      /> */}

      <CustomTable
        columnsData={billingOrdersHeading}
        rowData={tableData}
        // fixedData={fixedCol}
      />
    </div>
  );
};

export default CodData;
